import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SectionHead } from "@/components/site/PageHeader";
import { ModelCard } from "@/components/site/ModelCard";
import { Stagger, Item } from "@/components/motion/Reveal";

export const ModelShowcase = ({ vehicles = [], offers = [] }) => (
  <section id="models" data-testid="model-showcase" className="relative py-24 sm:py-32">
    <div className="wrap">
      <SectionHead
        number="01"
        eyebrow="The Lineup"
        lines={["Every JETOUR,", "one showroom."]}
        sub="From the seven-seat X70 Plus to the plug-in hybrid T2 i-DM. Every model on display on West Canal Road, ready to drive."
        right={<Link to="/models" data-testid="showcase-all-models-link" className="btn-ghost">All models <ArrowUpRight className="h-4 w-4" /></Link>}
      />
      <Stagger className="grid gap-4 md:grid-cols-2 lg:grid-cols-3" gap={0.1}>
        {vehicles.map((v, i) => (
          <Item key={v.slug} className={i === 0 ? "md:col-span-2" : ""}>
            <ModelCard vehicle={v} featured={i === 0} index={i} offer={offers.find((o) => o.vehicle_slug === v.slug)} />
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);
